import { GridRowModel } from '@mui/x-data-grid-pro';
import { getTotalQuantityFromStatusesForLocationIds, SkuItem } from 'common/modules/inventory';
import { isEmpty } from 'lodash';
import { SkuColumnFieldsWithTypes } from './columns';
import {
	getSkuAllocationsForLocations,
	getSkuInStockAmountForLocations,
	getSkuReservedAmountForLocations,
	SkuRowItemParams,
} from '../../utils';
import { getProductsBySkuId } from 'common/modules/products/utils';
import { ProductApi } from 'common/types';

export const getSkuRows = (params: SkuRowItemParams) => {
	const { skuItems, selectedLocationIds, stockProducts } = params;

	const validSkuItems = skuItems.filter((item) =>
		!selectedLocationIds?.length || isEmpty(item.statusesByLocation)
			? true
			: selectedLocationIds.some((locationId) => !isEmpty(item.statusesByLocation[locationId])),
	);

	const rows: GridRowModel[] = validSkuItems.map((item) =>
		skuItemToRow(item, stockProducts, selectedLocationIds),
	);
	return rows;
};

export const skuItemToRow = (
	skuItem: SkuItem,
	stockProducts: ProductApi[],
	locationIds?: string[],
): { id: string } & SkuColumnFieldsWithTypes => {
	const skuRow: { id: string } & SkuColumnFieldsWithTypes = {
		id: skuItem.id,
		sku_code: skuItem.skuCode,
		sku_name: skuItem.skuName,
		type: skuItem.itemType,
		articles: !locationIds?.length
			? skuItem.quantity
			: getTotalQuantityFromStatusesForLocationIds(skuItem.statusesByLocation, locationIds),
		products: getProductsBySkuId(stockProducts, skuItem.id).length,
		quantity: skuItem.quantity,
		in_stock: getSkuInStockAmountForLocations(
			skuItem,
			!!locationIds?.length ? locationIds : undefined,
		),
		for_sale: getSkuAllocationsForLocations(
			skuItem,
			'sales',
			!!locationIds?.length ? locationIds : undefined,
		),
		for_rent: getSkuAllocationsForLocations(
			skuItem,
			'rental',
			!!locationIds?.length ? locationIds : undefined,
		),
		committed: getSkuReservedAmountForLocations(
			skuItem,
			!!locationIds?.length ? locationIds : undefined,
		),
	};
	return skuRow;
};

export const rowToSkuItem = (
	props: SkuColumnFieldsWithTypes,
): Pick<SkuItem, 'skuCode' | 'skuName' | 'itemType'> => {
	const { sku_code, sku_name, type } = props;
	return {
		skuCode: sku_code,
		skuName: sku_name,
		itemType: type,
	};
};
